/**
 * @deprecated Ideally use @imminently/decisively-ui/Tabs directly instead
 * This component is deprecated and will be removed in a future version.
 * Please migrate to the core Tabs component.
 *
 * This component was updated to use the new component library as part of the mui 4 migration.
 */
import { Tooltip, type TooltipProps } from "@/components/toolTip";
import TabsCore from "@imminently/decisively-ui/Tabs";
import React from "react";

export interface TabItem {
  label: string;
  value: string;
  icon?: any;
  disabled?: boolean;
  tooltip?: true | TooltipProps;
}

export type TabsProps = {
  tabs: Array<TabItem>;
  current: string;
  onChange: (_: any, v: string) => unknown;
  className?: string;
};

export const Tabs = React.memo((props: TabsProps) => {
  const { current, tabs, onChange, className } = props;

  return (
    <TabsCore
      value={current}
      onValueChange={(v) => onChange(null, v)}
      className={className}
    >
      <TabsCore.List>
        {tabs.map((tab) => {
          const { value, label, icon, disabled, tooltip } = tab;
          const trigger = (
            <TabsCore.Trigger
              key={value}
              value={value}
              disabled={disabled}
            >
              {icon && <span className="mr-1">{icon}</span>}
              {label}
            </TabsCore.Trigger>
          );

          if (tooltip) {
            const tooltipProps = tooltip === true ? {} : tooltip;
            return (
              <Tooltip
                key={value}
                title={label}
                placement="bottom"
                {...tooltipProps}
              >
                {trigger}
              </Tooltip>
            );
          }

          return trigger;
        })}
      </TabsCore.List>
    </TabsCore>
  );
});

export default Tabs;
Tabs.displayName = "Components/Tabs";
